import * as actionTypes from "../actions";
const defaultState = {
    questionsSpec: [],
    fetchingQuestionsSpec: false,
    specDto: [],
    fetchingSpecDto: false,
};

const getGroupQuestionsSpec = (state, action) => {
    return {
        ...state,
        fetchingQuestionsSpec: true,
        questionsSpec: [],
    }
};

const getGroupQuestionsSpecSuccess = (state, action) => {
    return {
        ...state,
        fetchingQuestionsSpec: false,
        questionsSpec: action.payload,
    }
};
const getGroupQuestionsSpecFailure = (state, action) => {
    return {
        ...state,
        fetchingQuestionsSpec: false,
    }
};


const getGroupSpecDto = (state, action) => {
    return {
        ...state,
        fetchingSpecDto: true,
    }
};

const getGroupSpecDtoSuccess = (state, action) => {
    return {
        ...state,
        fetchingSpecDto: false,
        specDto: action.payload,
    }
};
const getGroupSpecDtoFailure = (state, action) => {
    return {
        ...state,
        fetchingSpecDto: false,
    }
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case actionTypes.GET_GROUP_QUESTIONS_SPEC: return getGroupQuestionsSpec(state, action);
        case actionTypes.GET_GROUP_QUESTIONS_SPEC_SUCCESS: return getGroupQuestionsSpecSuccess(state, action);
        case actionTypes.GET_GROUP_QUESTIONS_SPEC_FAILURE: return getGroupQuestionsSpecFailure(state, action);
        case actionTypes.GET_GROUP_SPEC_DTO: return getGroupSpecDto(state, action);
        case actionTypes.GET_GROUP_SPEC_DTO_SUCCESS: return getGroupSpecDtoSuccess(state, action);
        case actionTypes.GET_GROUP_SPEC_DTO_FAILURE: return getGroupSpecDtoFailure(state, action);
        case actionTypes.LOGOUT: return defaultState;
        default: return state;
    }
};
